import {create} from "zustand";
import {Applicant} from "../api/types/Applicant";

interface ApplicantState {
    applicant: Applicant | null;
    client: Applicant | null;
}

interface ApplicantStore extends ApplicantState {
    setApplicant: (Applicant: Applicant | null) => void;
    setClient: (Client: Applicant | null) => void;
}

export const useApplicantStore = create<ApplicantStore>()((set) => ({
    applicant: null,
    setApplicant: (applicant: Applicant | null) => {
        set(() => ({applicant}))
    },
    client: null,
    setClient: (Client: Applicant | null) => {
        set(() => ({client: Client}))
    }
}));